import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M11.0908 5.7193c0-.5477.4884-.9918 1.0909-.9918h3.6364c.6024 0 1.0909.444 1.0909.9918 0 .5477-.4885.9917-1.0909.9917h-3.6364c-.6025 0-1.0909-.444-1.0909-.9917m0 3.471c0-.5477.4884-.9917 1.0909-.9917h8.7272c.6025 0 1.0909.444 1.0909.9917s-.4884.9917-1.0909.9917h-8.7272c-.6025 0-1.0909-.444-1.0909-.9917M2 5.6365c0-1.0041.814-1.8181 1.8182-1.8181h3.6363c1.0042 0 1.8182.814 1.8182 1.8181V9.273c0 1.0041-.814 1.8181-1.8182 1.8181H3.8182C2.814 11.091 2 10.277 2 9.2729zm5.4545 0H3.8182V9.273h3.6363z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.091 14.81c0-.5477.4884-.9917 1.0909-.9917h3.6363c.6025 0 1.0909.444 1.0909.9917s-.4884.9917-1.0909.9917h-3.6363c-.6025 0-1.0909-.444-1.0909-.9917m0 3.4711c0-.5477.4884-.9918 1.0909-.9918h8.7272c.6025 0 1.0909.4441 1.0909.9918s-.4884.9917-1.0909.9917h-8.7272c-.6025 0-1.0909-.444-1.0909-.9917M2 14.7275c0-1.0041.814-1.8182 1.8182-1.8182h3.6363c1.0042 0 1.8182.8141 1.8182 1.8182v3.6364c0 1.0041-.814 1.8181-1.8182 1.8181H3.8182C2.814 20.182 2 19.368 2 18.3639z",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M11.0908 5.7193c0-.5477.4884-.9918 1.0909-.9918h3.6364c.6024 0 1.0909.444 1.0909.9918 0 .5477-.4885.9917-1.0909.9917h-3.6364c-.6025 0-1.0909-.444-1.0909-.9917m0 3.471c0-.5477.4884-.9917 1.0909-.9917h8.7272c.6025 0 1.0909.444 1.0909.9917s-.4884.9917-1.0909.9917h-8.7272c-.6025 0-1.0909-.444-1.0909-.9917M2 5.6365c0-1.0041.814-1.8181 1.8182-1.8181h3.6363c1.0042 0 1.8182.814 1.8182 1.8181V9.273c0 1.0041-.814 1.8181-1.8182 1.8181H3.8182C2.814 11.091 2 10.277 2 9.2729zm5.4545 0H3.8182V9.273h3.6363z",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.091 14.81c0-.5477.4884-.9917 1.0909-.9917h3.6363c.6025 0 1.0909.444 1.0909.9917s-.4884.9917-1.0909.9917h-3.6363c-.6025 0-1.0909-.444-1.0909-.9917m0 3.4711c0-.5477.4884-.9918 1.0909-.9918h8.7272c.6025 0 1.0909.4441 1.0909.9918s-.4884.9917-1.0909.9917h-8.7272c-.6025 0-1.0909-.444-1.0909-.9917M2 14.7275c0-1.0041.814-1.8182 1.8182-1.8182h3.6363c1.0042 0 1.8182.8141 1.8182 1.8182v3.6364c0 1.0041-.814 1.8181-1.8182 1.8181H3.8182C2.814 20.182 2 19.368 2 18.3639z",
        clipRule: "evenodd"
    }, "3")
], "CreativeNative", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
